import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export const isOrganizationBillingSetupError = error =>
  String(error?.Message ?? error?.data?.Message ?? '').startsWith(
    'Complete organization billing setup before '
  );

const OrganizationBillingSetupNotice = ({ canManage }) => (
  <Alert variant="warning">
    {canManage ? (
      <>
        Notaries can share journals with your organization. Add a payment method
        and set it as default to view and review them. Go to{' '}
        <Link to="/organization/billing/payment-methods">Payment Methods</Link>{' '}
        to complete billing setup.
      </>
    ) : (
      'Your organization administrator must complete billing setup before shared journals can be viewed or reviewed.'
    )}
  </Alert>
);

OrganizationBillingSetupNotice.propTypes = { canManage: PropTypes.bool };

export default OrganizationBillingSetupNotice;
